"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require(".");
var wishlist_1 = require("helpers/wishlist");
var WishlistCardIcon = /** @class */ (function (_super) {
    __extends(WishlistCardIcon, _super);
    function WishlistCardIcon(props) {
        var _this_1 = _super.call(this, props) || this;
        _this_1.checkWishlistItem = function () {
            if (!window._swat) {
                // console.error("Swat is not initialized");
                setTimeout(function () {
                    _this_1.checkWishlistItem();
                }, 1000);
            }
            else {
                wishlist_1.isInWishlist(_this_1.state.variant)
                    .then(function (res) {
                    _this_1.setState({ inWishlist: res });
                    _this_1.setState({ isWishlistLoading: false });
                })
                    .catch(function (err) {
                    console.log("err", err);
                });
            }
        };
        _this_1.componentDidMount = function () {
            _this_1.checkWishlistItem();
        };
        _this_1.componentDidUpdate = function (prevState) {
            if (prevState.variant.id != _this_1.state.variant.id) {
                _this_1.checkWishlistItem();
            }
        };
        _this_1.toggleWishlist = function () {
            var _this = _this_1;
            if (SwymPageData) {
                if (!_this_1.state.inWishlist) {
                    SwymPageData.et = 4; // et 4 stands for wishlist event type
                    SwymPageData.empi = parseInt(_this_1.state.product.id);
                    SwymPageData.epi = parseInt(_this_1.state.variant.id);
                    SwymPageData.du = window.location.origin + "/products/" + _this_1.state.product.handle;
                    _swat.addToWishList(SwymPageData, function (e) {
                        _this.setState({ inWishlist: true });
                        document.dispatchEvent(new CustomEvent("swym:wishlist-updated"));
                    });
                }
                else {
                    SwymPageData.et = 4; // et 4 stands for wishlist event type
                    SwymPageData.empi = parseInt(_this_1.state.product.id);
                    SwymPageData.epi = parseInt(_this_1.state.variant.id);
                    _swat.removeFromWishList(SwymPageData, function (e) {
                        _this.setState({ inWishlist: false });
                        document.dispatchEvent(new CustomEvent("swym:wishlist-updated"));
                    });
                }
            }
        };
        _this_1.state = {
            loggedIn: Object.keys(_this_1.props.customer).length != 0,
            inWishlist: false,
            product: _this_1.props.product,
            variant: _this_1.props.variant,
            isWishlistLoading: true
        };
        return _this_1;
    }
    WishlistCardIcon.prototype.render = function () {
        var _this_1 = this;
        if (!this.state.loggedIn) {
            return (React.createElement("a", { href: "/account/login", title: "Login to view your wishlist", className: "flex items-center justify-start cursor-pointer mb-0-8 no-underline" },
                React.createElement("span", { className: this.props.className + " " + this.props.variant.id },
                    React.createElement(Snippets.Svg, { name: "star", className: "w-1-6 fill-current pointer-events-none", width: 16 }))));
        }
        return (!this.state.isWishlistLoading && (React.createElement("div", { className: "flex items-center justify-start cursor-pointer mb-0-8", onClick: function () { return _this_1.toggleWishlist(); } },
            React.createElement("span", { className: this.props.className + " " + this.props.variant.id }, this.state.inWishlist ? (React.createElement(Snippets.Svg, { name: "star-active", className: "w-1-6 fill-current pointer-events-none", width: 16 })) : (React.createElement(Snippets.Svg, { name: "star", className: "w-1-6 fill-current pointer-events-none", width: 16 }))))));
    };
    return WishlistCardIcon;
}(React.PureComponent));
exports.WishlistCardIcon = WishlistCardIcon;
